<div class="content-calendar-widget">

  <div class="header-calendar is-subtitle1 fw-500">
    <span> {{ getCalendarDate() | titlecase }} </span>
    <div class="spacer"></div>
    <button mat-icon-button (click)="today()">
      <mat-icon class="m--0" [svgIcon]="'calendar'"></mat-icon>
    </button>
    <button mat-icon-button (click)="beforeMonth()" class="ml--5">
      <mat-icon class="m--0" [svgIcon]="'arrow_left'"></mat-icon>
    </button>
    <button mat-icon-button (click)="nextMonth()">
      <mat-icon class="m--0" [svgIcon]="'arrow_right'"></mat-icon>
    </button>
  </div>

  <mat-drawer-container class="calendar-content">
    <mat-drawer-content autosize class="calendar">
      <full-calendar #calendar [options]="calendarOptions">
      </full-calendar>
    </mat-drawer-content>

    <mat-drawer #sidenavPanel mode="side" class="sidenav" position="end">
      <div class="flex align-center">
        <div class="is-caption flex-grow">
          {{clickedEvent.caption}}
        </div>
        <mat-icon (click)="toggleSidenav()" [svgIcon]="'close'"></mat-icon>
      </div>

      <div *ngFor="let item of clickedEvent.text_body" class="text_body_div">
        <div *ngIf="checkLink(item.link)">
          <div class="is-body2">
            <a href={{item.link}} target="_blank" style="text-decoration:none;">
              {{clickedEvent.title}}
            </a>
          </div>
        </div>
        <div *ngIf="!item?.link && item.text">
          <div class="is-body2 black">
            <span style="text-decoration:none;">{{item.text}}</span>
          </div>
        </div>
      </div>
      <div class="is-caption description">
        <mat-icon class="icon-description" *ngIf="clickedEvent?.description_icon">
          {{clickedEvent?.description_icon}}
        </mat-icon>
        {{clickedEvent.description}}
      </div>

      <div *ngFor="let item of clickedEvent.chips" class="mat-chip-div">
        <mat-chip-listbox class="mat-chip-list">
          <mat-chip-option [style.color]="'white'" [style.background-color]="item.color"
            [style]="'flex-direction:row-reverse; border:1px solid'" [selectable]="false">
            {{ item.text}}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>

      <div *ngFor="let item of clickedEvent.bottom_links" class="bottom_body_div">
        <div *ngIf="checkLink(item.link)">
          <div class="is-body2 bottom_body_text">
            <a href={{item.link}} target="_blank" style="text-decoration:none;color:#6d6d6d">
              {{item.text}}
            </a>
          </div>
        </div>

        <div *ngIf="!checkLink(item.link)">
          <div class="is-body2 bottom_body_text">{{item.text}}</div>
        </div>
      </div>
    </mat-drawer>
  </mat-drawer-container>
</div>